export default __webpack_public_path__ + "static/media/Wolf Snarl.30a0dd4e.jpg";